export interface ServicesModel {
  id?: number;
  orgId?: number;
  name?: { [key: string]: string };
  description?: { [key: string]: string };
  price?: number;
  image?: string;
  isPublished: boolean;
  backgroundImage?: any;
  recommended?: boolean;
  isActive?: boolean;
  duration?: string;
  departmentUnitId?: number;
  departmentUnit?: DepartmentUnit;
}

export interface Description {
  en: string;
  fr: string;
}

export interface DepartmentUnit {
  id: number;
  orgId: number;
  departmentId: number;
  name: string;
  description: any;
  image: string;
  isActive: boolean;
  type: string;
  availableHours: any;
  adminId: any;
}

export enum ServiceTypeEnum {
  Reservable = 'reservable',
  Requestable = 'requestable'
}
